import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const a=i("dash",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static
        >
            <g clip-path="url(#clip0_5844_450)">
                <path
                    d="M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5Z"
                    fill="#008DE4"
                />
                <path
                    d="M14.5658 5.7793H8.53778L8.03841 8.57165L13.4805 8.5793C16.1607 8.5793 16.9531 9.55255 16.9301 11.1653C16.9174 11.9933 16.5607 13.392 16.4053 13.8455C15.9926 15.0532 15.1441 16.4341 11.9645 16.429L6.67281 16.4264L6.1709 19.2213H12.1862C14.3085 19.2213 15.2104 18.9742 16.1658 18.5334C18.2855 17.5551 19.5467 15.4634 20.0512 12.7347C20.8053 8.67102 19.8677 5.7793 14.5658 5.7793Z"
                    fill="white"
                />
                <path
                    d="M5.93374 11.0967C4.35412 11.0967 4.12737 12.126 3.9796 12.7476C3.78342 13.5629 3.71973 13.8916 3.71973 13.8916H9.89298C11.4726 13.8916 11.6993 12.8623 11.8471 12.2406C12.0433 11.4253 12.107 11.0967 12.107 11.0967H5.93374Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_5844_450">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    `);export{a as Dash};
